const STORAGE_KEY_PREFIX = 'webinar_checkout_';

function storageKey(productVariantId: string): string {
  return `${STORAGE_KEY_PREFIX}${productVariantId}`;
}

export function saveCheckoutClientSecret(productVariantId: string, clientSecret: string): void {
  try {
    localStorage.setItem(storageKey(productVariantId), clientSecret);
  } catch {
    // localStorage unavailable (SSR, private browsing quota) — silently ignore
  }
}

export function getCheckoutClientSecret(productVariantId: string): string | null {
  try {
    return localStorage.getItem(storageKey(productVariantId));
  } catch {
    return null;
  }
}

export function clearCheckoutClientSecret(productVariantId: string): void {
  try {
    localStorage.removeItem(storageKey(productVariantId));
  } catch {
    // silently ignore
  }
}
